import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';

export interface PersonalTitle {
    id: number,
    name: string
}

@Injectable()
export class PersonalTitlesService {

    constructor(private http: Http) {}

    getTitles(): Observable<PersonalTitle[]> {
        return this.http.get('/api/client/dictionary/titles').map(result => result.json())
            .map(result => {
                return result.titles.map(title => {
                    return ({
                        id: title.id,
                        name: title.name
                    })
                })
            });
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/dictionary/personal-titles.service.ts